import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { RoomStockManagementContainer } from "@/components/features/items/stock/room/ui";

import { useGetRoomStockPageParams } from "./_hooks/use-get-room-stock-page-params";

export const RoomStockPage = () => {
	const { hotelID } = useGetRoomStockPageParams();

	return (
		<PageMeta title="部屋在庫の設定" url={generatePath(PATHS.HOTEL.ITEMS.ROOM.STOCK, { hotelID })}>
			<RoomStockManagementContainer hotelID={hotelID} />
		</PageMeta>
	);
};

RoomStockPage.displayName = "RoomStockPage";
